import { useEffect, useState, useContext } from "react";
import Select from 'react-select';
import { ddStyles, ddStylesSmall } from "../utils/CommonStyles.js";
import FetchUtil from "../utils/FetchUtil";
import UserContext from "../contexts/UserContext";

let locationOptions = [];
let delegateOptions = [];

function UserDelegateLocationTableRow({ index, userDelegates, companyId, handleSubmit, setError, t, setAdd, oddIdx }) {
	const [userDelegateLoaded, setUserDelegateLoaded] = useState(false);
	const [userDelegateSelected, setUserDelegateSelected] = useState({ name: "delegateKey", label: "", value: "0-0-0-0" });
	const [locationLoaded, setLocationLoaded] = useState(false);
	const [locationSelected, setLocationSelected] = useState({ name: "locationKey", label: "", value: "0-0" });
	const [isSubmit, setIsSubmit] = useState(false);
	const [isLocationLoading, setIsLocationLoading] = useState(false);
	const userCtx = useContext(UserContext);
	
	let userCompanyId = userCtx.userCompanyId;
	useEffect(() => {
		setUserDelegateValues(userDelegates);
	}, []);

	function setUserDelegateValues(delegateObj) {
		let delegateValue = {};
		delegateOptions = [];
		if (delegateObj && delegateObj.length > 0) {
			delegateObj.map((aDelegate, idx) => {
				delegateValue.label = aDelegate.parentCompanyName;
				delegateValue.value = aDelegate.userDelegateKey + "-" + aDelegate.companyId + "-" + aDelegate.buyerKey + "-" + aDelegate.level;
				delegateOptions.push(delegateValue);
				delegateValue = {};
			});
			setUserDelegateLoaded(true);
		}
	}
	const delegateHandler = (selectedOption, action) => {
		let delegateKeys = selectedOption ? selectedOption.value : 0;
		let delegateLabel = selectedOption ? selectedOption.label : "";
		setUserDelegateSelected({ ...userDelegateSelected, label: (delegateLabel), value: delegateKeys });
		setLocationValues({});
		setLocationLoaded(false);
		fetchDelegateLocations(delegateKeys);
	}
	const locationHandler = (selectedOption, action) => {
		let locationKey = selectedOption ? selectedOption.value : 0;
		let locationName = selectedOption ? selectedOption.label : "";
		setLocationSelected({ ...locationSelected, label: (locationName), value: locationKey });
	}

	function fetchDelegateLocations(delegateValues) {
		setError("");
		let delegateValueArr=[];
		let buyerKey = 0;
		let level = 0;
		let delegateCompanyId = 0;
		if(delegateValues){
			delegateValueArr = delegateValues.split("-");
		}
		if(delegateValueArr.length >= 4){
			delegateCompanyId = delegateValueArr[1];
			buyerKey = delegateValueArr[2];
			level = delegateValueArr[3];
		}
		if ((!companyId || companyId === 0)) {
			setErrorValue(t("error.indirectBuyer.Reqd"));
			return;
		}else if ((!buyerKey || buyerKey === 0)) {
			setErrorValue(t("error.buyer.Reqd"));
			return;
		}else if(delegateCompanyId === 0){
			setError(t("error.delegateKeyReqd"));
			setIsSubmit(false);
		}
		setLocationValues([]);
		setIsLocationLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: false,
				indirectBuyerKey: companyId,
				buyerKey: buyerKey,
				level: level,
				companyKey: delegateCompanyId,
			}),
		};
		try {
			FetchUtil.fetchAPI("GetDelegateLocations", "/Service/CompanyService/GetDelegateLocations", requestOptions, retrieveWorkLocationSuccess, retrieveWorkLocationFail);
		} catch (error) {
			setIsLocationLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveWorkLocationFail(redirect) {
		setIsLocationLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.delegateLocationNotRetrieved"));
	}

	function retrieveWorkLocationSuccess(responseData) {
		let getDelegateLocationResponse;
		if (responseData) {
			getDelegateLocationResponse = responseData.getDelegateLocationResponse;
			if (getDelegateLocationResponse && getDelegateLocationResponse.errorCode === "0") {
				setLocationValues(getDelegateLocationResponse.delegateLocations.slice());
			} else if (getDelegateLocationResponse && getDelegateLocationResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getDelegateLocationResponse) {
				setError(t("error.error") + " " + getDelegateLocationResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsLocationLoading(false);
	}

	function setLocationValues(locationObj) {
		let locationValue = {};
		locationOptions = [];
		locationOptions.push({ label: "", value: "0-0" });
		if (locationObj && locationObj.length > 0) {
			locationObj.map((aLoc, idx) => {
				locationValue.label = aLoc.locationName + "-" + aLoc.departmentName;
				locationValue.value = aLoc.delegateLocationKey + "-" + aLoc.locationKey;
				locationOptions.push(locationValue);
				locationValue = {};
			});
			setLocationLoaded(true);
		}
	}


	function submitComplete() {
		setIsSubmit(false);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let locationValues = locationSelected.value;
		let locationValArr = [];
		
		let initialValues = {
			locationKey: 0,
			delegateLocationKey: 0,
			userDelegateKey: 0,
			delegateCompanyId: 0,
			buyerKey: 0,
			level:0
		};
		let delegateValues = userDelegateSelected.value;
		let delegateValueArr = [];
		if(delegateValues){
			delegateValueArr = delegateValues.split("-");
		}
		if(delegateValueArr.length >= 4){
			initialValues.userDelegateKey = delegateValueArr[0];
			initialValues.delegateCompanyId =  delegateValueArr[1];
			initialValues.buyerKey = delegateValueArr[2];
			initialValues.level = delegateValueArr[3];
		} 
		if(locationValues){
			locationValArr = locationValues.split("-");
		}
		if(locationValArr.length >= 2){
			initialValues.delegateLocationKey = locationValArr[0];
			initialValues.locationKey = locationValArr[1];
		}
		if (initialValues.userDelegateKey === 0) {
			setError(t("error.userDelegateKeyReqd"));
			setIsSubmit(false);
		} else if(initialValues.delegateCompanyId === 0){
			setError(t("error.delegateKeyReqd"));
			setIsSubmit(false);
		} else if(initialValues.buyerKey === 0){
			setError(t("error.buyer.Reqd"));
			setIsSubmit(false);
		} else if (initialValues.locationKey === 0) {
			setError(t("error.locNameReqd"));
			setIsSubmit(false);
		} else {
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
		setUserDelegateSelected({ name: "delegateKey", label: "", value: "0-0-0-0" });
		setLocationSelected({ name: "locationKey", label: "", value: "0-0" });
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{userDelegateLoaded ? <Select
					name="delegateKey"
					options={delegateOptions}
					onChange={delegateHandler}
					placeholder={""}
					value={userDelegateSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="delegateKey-input"
					styles={ddStylesSmall}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{locationLoaded ? <Select
					name="locationKey"
					options={locationOptions}
					onChange={locationHandler}
					placeholder={""}
					value={locationSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="locationKey-input"
					styles={ddStyles}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{(locationOptions && locationOptions.length >0 && delegateOptions && delegateOptions.length >0) ?
				(<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>) 
				:
				(<></>)
				}
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
		</tr>
	)

}
export default UserDelegateLocationTableRow;